<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 12 }"
    >

      <a-row :gutter="18">
          <a-form-item label="参数名"
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 12 }">
            <a-input v-decorator="['scKey', rules.scKey]"/>
          </a-form-item>
      </a-row>
      <a-row :gutter="18">
          <a-form-item label="参数值"
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 12 }">
            <a-input v-decorator="['scValue', rules.scValue]"/>
          </a-form-item>
      </a-row>

      <a-row :gutter="18">
        <a-form-item label="描述"
                     :label-col="{ span: 6 }"
                     :wrapper-col="{ span: 12 }">
          <a-textarea v-decorator="['description']"></a-textarea>
        </a-form-item>
      </a-row>

    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save()" v-auth="`UPDATE`">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/comm/ecSettingsManage';


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    scKey: {
      rules: [{required: true, message: "请输入参数名"}]
    },
    scValue: {
      rules: [{required: true, message: "请输入参数值"}]
    },
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}



/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  entities.id = vm.keyId;
  entities.createUserId = vm.createUserId;
  entities.createDate = vm.createDate;
  return await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {},
  data() {
    return {
      editStatus: false,
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate
  },
};
</script>

<style scoped lang="less">
</style>